import { axiosInstance as apiClient } from '@/lib/api';
import { KipiverseInquiryResponse, KipiverseInquirySingleResponse } from '../types';
import type { KIPIVERSE_INQUIRY_MSG_FROM } from '@/utils/constants';

interface GetParams {
  page?: number;
  limit?: number;
  status?: string;
  msgFrom?: KIPIVERSE_INQUIRY_MSG_FROM;
  sortColumn?: string;
  sortBy?: string;
  order?: 'ASC' | 'DESC';
}

export const getKipiverseInquiries = async (
  params?: GetParams,
): Promise<KipiverseInquiryResponse> => {
  const { sortColumn, sortBy, order, ...rest } = params || {};
  const activeSortCol = sortColumn || sortBy || 'createdAt';
  const activeOrder = order || 'DESC';
  const queryParams = {
    ...rest,
    'order[0][0]': activeSortCol,
    'order[0][1]': activeOrder,
  };
  const response = await apiClient.get('/kipiverseInquirys/paginatedRecords', { params: queryParams });
  return response as unknown as KipiverseInquiryResponse;
};

export const getKipiverseInquiryById = async (
  id: string,
): Promise<KipiverseInquirySingleResponse> => {
  const response = await apiClient.get(`/kipiverseInquirys/${id}`);
  return response as unknown as KipiverseInquirySingleResponse;
};

export const updateKipiverseInquiryStatus = async (
  id: string,
  data: { status: string },
): Promise<KipiverseInquirySingleResponse> => {
  const response = await apiClient.put(`/kipiverseInquirys/${id}`, data);
  return response as unknown as KipiverseInquirySingleResponse;
};
